import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { api } from '../services/api';
import { UserProfile } from '../services/types';
import { BusinessDashboardPage } from './BusinessDashboardPage';
import { PlatformAdminPage } from './PlatformAdminPage';

export function PanelPage() {
  const { loading: authLoading, session, token, logout } = useAuth();
  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) return;
    api<UserProfile>('/me', token).then(setProfile).catch((failure) => setError(failure instanceof Error ? failure.message : 'No pudimos cargar tu perfil.'));
  }, [token]);

  if (authLoading) return <div className="route-loading">Preparando tu panel…</div>;
  if (!session) return <Navigate to="/login" replace />;
  if (error) return <div className="route-loading"><b>No pudimos abrir el panel.</b><span>{error}</span><button onClick={logout}>Cerrar sesión</button></div>;
  if (!profile) return <div className="route-loading">Consultando tus permisos…</div>;
  if (profile.groups.includes('platform_admin')) return <PlatformAdminPage token={token} email={profile.email} onLogout={logout} />;
  return <BusinessDashboardPage token={token} profile={profile} onLogout={logout} />;
}
